if (!customElements.get('zv-product-info-tabs')) {
  customElements.define(
    'zv-product-info-tabs',
    class ZvProductInfoTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('.zv-product-info-tabs__nav-item'));
        this.panels = Array.from(this.querySelectorAll('.zv-product-info-tabs__panel'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      selectTab(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);

          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      onKeydown(event, index) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        } else {
          return;
        }

        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.selectTab(nextIndex);
      }
    }
  );
}
